module.exports = __webpack_public_path__ + "static/media/test.9ffbf678.md";